import { create } from "zustand";
import agent from "../services/api";
import { CommonResponseModel, organizationTeamsData, organizationTeamUsersData } from "../models/axiosModel";
import { formatOrganizationTeamsList } from "../components/dashboard/organization/teams/constant.teams";
interface organizationTeamsStoreInterface {
    organizationTeamsData: organizationTeamsData[] | null,
    setOrganizationTeamsData: (value: organizationTeamsData[] | null) => void,

    getOrganizationTeamsListApi: () => Promise<CommonResponseModel<organizationTeamsData>>,

    selectedTeam: organizationTeamsData | null,
    setSelectedTeam: (value: organizationTeamsData | null) => void,

    filteredOrganizationTeamsData: organizationTeamsData[] | null,
    setFilteredOrganizationTeamsData: (value: organizationTeamsData[] | null) => void,

    selectedTeamMembers: organizationTeamUsersData[],
    setSelectedTeamMembers: (value: organizationTeamUsersData[]) => void,

    createNewTeamPopup: boolean,
    setCreateNewTeamPopup: (value: boolean) => void,

    editTeamPopup: boolean,
    setEditTeamPopup: (value: boolean) => void,

    deleteTeamPopup: boolean,
    setDeleteTeamPopup: (value: boolean) => void,
    handleDeleteTeam: () => Promise<CommonResponseModel<void>>,
}

export const useOrganizationTeamsStore = create<organizationTeamsStoreInterface>((set, get) => ({
    organizationTeamsData: null,
    setOrganizationTeamsData: (value: organizationTeamsData[] | null) => set({ organizationTeamsData: value }),

    getOrganizationTeamsListApi: async () => {
        const res = await agent.getOrganizationTeamsList.get();
        if (res.status) {
            const organizationTeamsList = formatOrganizationTeamsList(res.data);
            set({ organizationTeamsData: organizationTeamsList, filteredOrganizationTeamsData: organizationTeamsList });
        } else {
            set({ organizationTeamsData: null, filteredOrganizationTeamsData: null });
        }
        return res;
    },

    selectedTeam: null,
    setSelectedTeam: (value: organizationTeamsData | null) => set({ selectedTeam: value }),

    filteredOrganizationTeamsData: null,
    setFilteredOrganizationTeamsData: (value: organizationTeamsData[] | null) => set({ filteredOrganizationTeamsData: value }),

    selectedTeamMembers: [],
    setSelectedTeamMembers: (value: organizationTeamUsersData[]) => set({ selectedTeamMembers: value }),

    createNewTeamPopup: false,
    setCreateNewTeamPopup: (value: boolean) => set({ createNewTeamPopup: value }),

    editTeamPopup: false,
    setEditTeamPopup: (value: boolean) => set({ editTeamPopup: value }),

    deleteTeamPopup: false,
    setDeleteTeamPopup: (value: boolean) => set({ deleteTeamPopup: value }),

    handleDeleteTeam: async () => {
        const res = await agent.deleteOrganizationTeam.delete(get().selectedTeam?.organization_team_id ?? "");
        if (res.status) {
            set({
                selectedTeam: null,
                deleteTeamPopup: false,
            });
            await get().getOrganizationTeamsListApi();
        }
        return res;
    },
}))